(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('SecurityService', function($log, $rootScope, $location, $timeout, NotificationService, $translate) {

		var permMatrix = {};
		var userRoles = [];

		/*
		 * Initialize the security service
		 */
		this.initMatrix = function(matrix) {
			permMatrix = matrix;

			$log.debug('SecurityService: Permission matrix initialized.');
		};

		/*
		 * Initialize security roles
		 */
		this.initUserRoles = function(roles) {
			userRoles = roles;

			if (roles && roles.length > 0) {
				$rootScope.$broadcast('security-loaded');
				$log.debug('SecurityService: User roles initialized: ' + JSON.stringify(roles));
			} else {
				this.rejectUser();
			}
		};

		var getKey = function(role, action) {
			var key = '';
			if (role && action) {
				key = role.toUpperCase() + '___' + action.toUpperCase();
			}
			return key;
		};

		this.setDroit = function(action, droit) {
			permMatrix[action] = droit;
		};

		/**
		 * get a droit for a role and an action
		 * @param {type} role the role to check
		 * @param {type} action the action to list
		 * @returns {TypeDroit} the droit attached
		 */
		this.getDroit = function(role, action) {
			var droit = 'NONE';
			var d = permMatrix[getKey(role, action)];
			if (d) {
				droit = d;
			}
			return droit;
		};

		this.getMatrix = function() {
			return permMatrix;
		};

		/**
		 *
		 * @param {type} action the action to get the droits
		 * @returns {TypeDroit[]} the droits associated for the action
		 */
		this.getDroits = function(action) {
			var droits = [];

			for (var i = 0; i < userRoles.length; i++) {
				var r = userRoles[i];
				var d = this.getDroit(r, action);
				if (d && d !== 'NONE') {
					droits.push(d);
				}
			}

			if (droits.length === 0) {
				droits.push('NONE');
			}

			return droits;
		};




		this.getUserRoles = function() {
			return userRoles;
		};

		var checker = {};
		/**
		 * Add a checker for a desired action and resource
		 * This is used for custom permission checks
		 * @param {TypeAction} action
		 * @param {function} fn the function called to check if the user has right: boolean fn(droit, resourceValue, options)
		 *
		 */
		this.addPermissionChecker = function(action, fn) {
			var spl = action.split('\.');
			var resource = spl[0];
			var act = spl[1];
			if (!checker[resource]) {
				checker[resource] = {};
			}
			checker[resource][act] = fn;
		};

		/**
		 * Add multiple checkers for desired actions and resource
		 * This is used for custom permission checks
		 * @param {TypeAction[]} actions
		 * @param {function} fn the function called to check if the user has right: boolean fn(droit, resourceValue, options)
		 *
		 */
		this.addPermissionCheckers = function(actions, fn) {
			if (actions && actions.length > 0) {
				for (var i = 0; i < actions.length; i++) {
					var action = actions[i];
					this.addPermissionChecker(action, fn);
				}
			}
		};

		/**
		 * Ask the permission service if the currently connected user has the rights to perform an action
		 * @param {type} action the action to test
		 * @param {type} resourceValue
		 * @param {type} options
		 * @returns {Boolean} true if the user has the right to perform the desired operation
		 *
		 * Example: ELEVE.LIST (from perm matrix) -> function(ELEVE.LIST, value, options)
		 */
		this.hasResourcePermission = function(action, resourceValue, options) {

			// Simple check. If we find "ALL", we don't need to check more...
			if (this.hasDroit(action, ['ALL'])) {
				return true;
			}

			// When resource is null, we return false
			if (!resourceValue) {
				return false;
			}

			var spl = action.split('\.');
			var resource = spl[0];
			var act = spl[1];

			var result = false;
			if (checker[resource] && checker[resource][act]) {
				var droits = this.getDroits(action);
				for (var i = 0; i < droits.length; i++) {
					var droit = droits[i];
					if (!(droit === 'NONE')) {
						result = checker[resource][act](droit, resourceValue, options);
						if (result) {
							break;
						}
					}
				}
			} else {
				$log.warn('SecurityService: No checker found for resource.action: ' + action + '!');
			}
			return result;
		};

		/**
		 * Check if at least 1 "droit" is authorized from the list of "droits"
		 * @param {TypeAction} action
		 * @param {TypeDroit[]} droits list of droit (a or is make between droits) (could be also a single object)
		 * @returns {boolean} true if permissions match
		 */
		this.hasDroit = function(action, droits) {
			var avDroits = this.getDroits(action);
			var reqDroits = [];
			if (droits instanceof Array) {
				reqDroits = droits;
			} else {
				reqDroits.push(droits);
			}

			var permitted = false;

			// Let's see if we find a corresponding droit
			for (var i = 0; i < avDroits.length; i++) {
				var avd = avDroits[i];
				if (avd === 'ALL') {
					permitted = true;
					break;
				} else {
					for (var j = 0; j < reqDroits.length; j++) {
						if (reqDroits[j] === avd) {
							permitted = true;
							break;
						}
					}
				}
			}

			return permitted;
		};

		/**
		 * Returns true if at least 1 droit is not NONE
		 * @param {ActionType} action the action to test
		 * @returns {boolean} true if any role is different than NONE
		 */
		this.hasAnyDroit = function(action) {
			var permitted = false;
			var avDroits = this.getDroits(action);
			// Let's see if we find a corresponding droit
			for (var i = 0; i < avDroits.length; i++) {
				var avd = avDroits[i];
				if (avd && avd !== 'NONE') {
					permitted = true;
					break;
				}
			}
			return permitted;
		};

		/**
		 * Called when the user has no rights over the application
		 * In that case we redirect the view to the corresponding view
		 */
		this.rejectUser = function() {
			$rootScope.$broadcast('user-security-rejected');
		};

		/**
		 * This method reject the current location (user is redirected) and a message is displayed
		 */
		this.rejectLocation = function() {
			$timeout(function() {
				NotificationService.notify('WARN', $translate.instant('error.security.location.rejected'));
				$location.path('/');
			});
		};

		this.hasRole = function(role) {
			for (var i = 0; i < userRoles.length; i++) {
				if (userRoles[i] === role) {
					return true;
				}
			}
			return false;
		};
	});

	/* Security directives */
	/*
	 * Used to disable functionalities of the app with the security service
	 * @param {String} securedAction: TODO
	 * @param {String} policy:  hide (css hide), remove (remove elements from the dom), disable (add ng-disabled)
	 * @param {String} disabledText: Displays this text when the security is not allowed
	 * @param {String} hasAny see SecurityService.hasAnyDroit()
	 * @param {String} hasAnyOf see SecurityService.hasDroit()
	 * @param {Object} hasResourcePermission see SecurityService hasResourcePermission
	 *		hasResourcePermission's object definition:
	 *			{
	 *				resourceValue: The resource itself
	 *				options: Options to transmit
	 *			}
	 */
	core.directive('stlSecured', function($log, SecurityService) {
		return {
			transclude: true,
			scope: {
				'securedAction': '=',
				'hasAny': '@',
				'hasAnyOf': '=',
				'policy': '@',
				'disabledText': '=',
				'hasResourcePermission': '=',
				'hasRole': '='
			},
			restrict: 'E',
			replace: true,
			template: '<span>' +
					'<span class="stl-secured-area" ng-show="!secHidden" ng-transclude></span>' +
					'<span ng-if="secHidden && disabledText">{{disabledText}}</span>' +
					'</span>',
			link: function(scope, element, attrs) {
				var permitted = false;

				scope.secHidden = false;
				scope.secDisabled = false;

				var lastSecurityApply = {
					securedAction: undefined,
					hasResourcePermission: undefined
				};

				var applySecurity = function() {
					lastSecurityApply.securedAction = scope.securedAction;
					lastSecurityApply.hasResourcePermission = scope.hasResourcePermission;

					// Handle security...
					if (!scope.securedAction) {
						$log.warn('stlSecured: no secured-action set ! don\'t forget to use \'SECURED_ACTION\' when static !');
						permitted = false;
					} else if (attrs['hasAny'] !== undefined) {
						permitted = SecurityService.hasAnyDroit(scope.securedAction);
					} else if (attrs['hasAnyOf'] !== undefined) {
						permitted = SecurityService.hasDroit(scope.securedAction, scope.hasAnyOf);
					} else if (attrs['hasResourcePermission'] !== undefined) {
						permitted = false;
						var params = scope.hasResourcePermission;
						if (params) {
							permitted = SecurityService.hasResourcePermission(
									scope.securedAction, params.resourceValue, params.options);
						} else {
							permitted = false;
						}
					} else if (attrs['hasRole']) {
						permitted = SecurityService.hasRole(attrs['hasRole']);
					}

					var policy = 'hide';
					if (scope.policy) {
						policy = scope.policy;
					}

					if (policy === 'remove') {
						if (!permitted) {
							element.find('span.stl-secured-area').remove();
						}
						scope.secHidden = !permitted;
					} else if (policy === 'disable') {
						if (!permitted) {
							var inputs = element.find('input');
							inputs.attr('disabled', true);
						}
					} else {
						scope.secHidden = !permitted;
					}
				};

				scope.$watchCollection('[securedAction, hasResourcePermission]', function(newVal, oldVal) {
					if (!angular.equals(newVal, oldVal)
							|| lastSecurityApply.securedAction !== newVal[0]
							|| lastSecurityApply.hasResourcePermission !== newVal[1]) {
						applySecurity();
					}
				}, true);
				applySecurity();

			}
		};
	});

	/*
	 * Used to disable functionalities of the app with the security service
	 *
	 */
	core.directive('hasAnyRight', function(SecurityService, $rootScope) {
		return {
			scope: true,
			restrict: 'A',
			link: function(scope, element, attrs) {
				var permitted = false;
				var securedAction = null;
				if (attrs['securedAction'] !== undefined) {
					securedAction = attrs['securedAction'];
				}

				var apply = function() {
					// Handle security...
					if (securedAction && attrs['hasAnyRight'] !== undefined) {
						permitted = SecurityService.hasAnyDroit(securedAction);
					}

					if (!permitted) {
						element.hide();
					} else {
						element.show();
					}
				};
				apply();

				$rootScope.$on('security-loaded', function() {
					apply();
				});
			}
		};
	});
})(angular);
